import { useQuery } from "@apollo/react-hooks";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { VacationManagement } from "../../Components/VacationManagement";
import { GET_LAST_SCREEN } from "../../Graphql/queries";
import { AnnouncementsListPage } from "../../Pages/Announcements";
import { ForgotPasswordPage } from "../../Pages/Auth/ForgotPassword";
import { LoginPage } from "../../Pages/Auth/Login";
import { OtpVerificationPage } from "../../Pages/Auth/OtpVerification";
import { ResetPasswordPage } from "../../Pages/Auth/ResetPassword";
import { SignupPage } from "../../Pages/Auth/SignUp";
import { DashboardPage } from "../../Pages/Dashboard";
import { EmployeesListPage } from "../../Pages/Employees";
import { EmployeeManageTasksPage } from "../../Pages/Employees/Detail/EmployeeManageTasks";
import { EmployeePersonalDetailsPage } from "../../Pages/Employees/Detail/PersonalDetails";
import { LocationEdit } from "../../Pages/Locations/LocationEdit";
import { LocationList } from "../../Pages/Locations/LocationList";
import { ConfirmDetailsPage } from "../../Pages/Onboarding/Manager-Employee/ConfirmDetails";
import { NotificationSetupPage } from "../../Pages/Onboarding/Manager-Employee/NotificationSetup";
import { ShiftManagementPage } from "../../Pages/Onboarding/Manager-Employee/ShiftManagement/ShiftManagement";
import { AreaManagerOnboarding } from "../../Pages/Onboarding/Owner/AreaManager";
import { OnboardingBusinessDetails } from "../../Pages/Onboarding/Owner/BusinessDetails";
import { EmployeeDetailsManagementPage } from "../../Pages/Onboarding/Owner/EmployeeDetailsManagement";
import { EmployeeReportingManagement } from "../../Pages/Onboarding/Owner/EmployeeReportingManagement";
import { EmployeeRoleManagementPage } from "../../Pages/Onboarding/Owner/EmployeeRoleManagement";
import { LocationManagementPage } from "../../Pages/Onboarding/Owner/LocationManagement";
import { CustomPaymentPage } from "../../Pages/Onboarding/Owner/Payment/CustomPayment";
import { ReviewPayment } from "../../Pages/Onboarding/Owner/Payment/ReviewPayment";
import { EmployeePerformanceReportPage } from "../../Pages/Reports/EmployeePerformanceReport/EmployeePerformanceReport";
import { LocationPerformanceReportPage } from "../../Pages/Reports/LocationPerformanceReport/LocationPerformanceReport";

import { EmployeeTaskStatus } from "../../Pages/Employees/Detail/EmployeeTaskStatus";
import { SelectPackage } from "../../Pages/Onboarding/Owner/Payment/SelectPackage";
import { ThankYouPage } from "../../Pages/Onboarding/Owner/ThankYou";
import { BusinessInformationPage } from "../../Pages/Settings/BusinessInformation";
import { ChangePassword } from "../../Pages/Settings/ChangePassword";
import { Profile } from "../../Pages/Settings/Profile";
import { Subscriptions } from "../../Pages/Settings/Subscriptions";
import { TaskList } from "../../Pages/Tasks/TaskList";
import { Tasks } from "../../Pages/Tasks/Tasks";
import { VerifyEmailPage } from "../../Pages/VerifyEmail";
import { VideosPage } from '../../Pages/Videos';
import { WelcomePage } from "../../Pages/Welcome";
import { DashboardTemplate } from "../../Template/Dashboard";
import { OnboardingTemplate } from "../../Template/Onboarding";
import { SubDashboardTemplate } from "../../Template/SubDashboard";
import { PrivateRoutes } from "./PrivateRoute";

export const Routes = () => {
  const { data } = useQuery(GET_LAST_SCREEN, {
    variables: { user_id: localStorage.getItem("user_id") },
    fetchPolicy: "cache-and-network",
    context: {
      headers: {
        subscription: 1,
      },
    },
    skip: !localStorage.user_id,
  });

  return (
    <Switch>
      <Route
        exact
        path="/welcome"
        render={(props) => {
          if (!data?.getUsersById?.last_screen) {
            return (
              <OnboardingTemplate>
                <WelcomePage {...props} />
              </OnboardingTemplate>
            );
          } else {
            return <Redirect to={data?.getUsersById?.last_screen} />;
          }
        }}
      />
      <Route
        path="/signup"
        render={(props) => {
          if (!data?.getUsersById?.last_screen) {
            return (
              <OnboardingTemplate>
                <SignupPage {...props} />
              </OnboardingTemplate>
            );
          } else {
            return <Redirect to={data?.getUsersById?.last_screen} />;
          }
        }}
      />
      <Route
        path="/login"
        render={(props) => {
          if (!data?.getUsersById?.last_screen) {
            return (
              <OnboardingTemplate>
                <LoginPage {...props} />
              </OnboardingTemplate>
            );
          } else {
            return <Redirect to={data?.getUsersById?.last_screen} />;
          }
        }}
      />
      <Route
        path="/otp-verification"
        render={(props) => {
          if (!localStorage.user_id) {
            return <Redirect to="/welcome" />;
          }
          if (!data?.getUsersById?.last_screen) {
            return (
              <OnboardingTemplate>
                <OtpVerificationPage {...props} />
              </OnboardingTemplate>
            );
          } else {
            return <Redirect to={data?.getUsersById?.last_screen} />;
          }
        }}
      />
      <Route
        exact
        path="/forgot-password"
        render={(props) => {
          if (!data?.getUsersById?.last_screen) {
            return (
              <OnboardingTemplate>
                <ForgotPasswordPage {...props} />
              </OnboardingTemplate>
            );
          } else {
            return <Redirect to={data?.getUsersById?.last_screen} />;
          }
        }}
      />
      <PrivateRoutes
        path="/reset-password"
        template={OnboardingTemplate}
        PageContent={ResetPasswordPage}
      />
      <PrivateRoutes
        path="/forgot-password"
        template={OnboardingTemplate}
        PageContent={ForgotPasswordPage}
      />
      <PrivateRoutes
        path="/verify-details"
        template={OnboardingTemplate}
        PageContent={OtpVerificationPage}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/confirm-details"
        template={OnboardingTemplate}
        PageContent={ConfirmDetailsPage}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/business-details"
        template={OnboardingTemplate}
        PageContent={OnboardingBusinessDetails}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/thank-you"
        template={OnboardingTemplate}
        PageContent={ThankYouPage}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/payment-plan"
        template={OnboardingTemplate}
        PageContent={SelectPackage}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/review-payment"
        template={OnboardingTemplate}
        PageContent={ReviewPayment}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/stripe-payment"
        template={OnboardingTemplate}
        PageContent={CustomPaymentPage}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/location"
        template={OnboardingTemplate}
        PageContent={LocationManagementPage}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/area-manager"
        template={OnboardingTemplate}
        PageContent={AreaManagerOnboarding}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/employee-roles"
        template={OnboardingTemplate}
        PageContent={EmployeeRoleManagementPage}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/employee-details"
        template={OnboardingTemplate}
        PageContent={EmployeeDetailsManagementPage}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/notification-setup"
        template={OnboardingTemplate}
        PageContent={NotificationSetupPage}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/shift-management"
        template={OnboardingTemplate}
        PageContent={ShiftManagementPage}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        path="/on-boarding/employee-reporting"
        template={OnboardingTemplate}
        PageContent={EmployeeReportingManagement}
        lastScreen={data?.getUsersById?.last_screen}
      />
      <PrivateRoutes
        exact
        path="/location"
        template={DashboardTemplate}
        title="Location"
        PageContent={LocationList}
      />
      <PrivateRoutes
        path="/location/:id/edit"
        template={DashboardTemplate}
        title="Location"
        PageContent={LocationEdit}
      />
      <PrivateRoutes
        exact
        path="/"
        template={DashboardTemplate}
        title="Dashboard"
        PageContent={DashboardPage}
      />
      <Route
        exact
        path={"/task/my-tasks"}
        render={(props) => {
          if (!data?.getUsersById?.last_screen) {
            return (
              <Redirect to="/tasks/my-tasks" />
            );
          }
          else {
            return <Redirect to={data?.getUsersById?.last_screen} />;
          }
        }}
      />
       <PrivateRoutes
        path="/tasks/my-tasks"
        template={DashboardTemplate}
        title="My Tasks"
        PageContent={TaskList}
      />
      <PrivateRoutes
        exact
        path="/employee"
        template={DashboardTemplate}
        title="Employees"
        PageContent={EmployeesListPage}
      />
      <PrivateRoutes
        path="/employee/:employee_id/personal-details"
        template={DashboardTemplate}
        SubTemplate={SubDashboardTemplate}
        title="Employees"
        PageContent={EmployeePersonalDetailsPage}
      />
      <PrivateRoutes
        path="/employee/:employee_id/tasks"
        template={DashboardTemplate}
        SubTemplate={SubDashboardTemplate}
        title="Employees"
        PageContent={EmployeeManageTasksPage}
      />
      <PrivateRoutes
        path="/employee/:employee_id/vacation"
        template={DashboardTemplate}
        SubTemplate={SubDashboardTemplate}
        title="Employees"
        PageContent={VacationManagement}
      />
      <PrivateRoutes
        path="/employee/:employee_id/status"
        template={DashboardTemplate}
        SubTemplate={SubDashboardTemplate}
        title="Employees"
        PageContent={EmployeeTaskStatus}
      />
      <PrivateRoutes
        exact
        path="/tasks"
        template={DashboardTemplate}
        title="Tasks"
        PageContent={Tasks}
      />
      <Route
        exact
        path="/settings"
        render={() => <Redirect to="/settings/profile" />}
      />
      <PrivateRoutes
        path="/settings/business-information"
        template={DashboardTemplate}
        SubTemplate={SubDashboardTemplate}
        title="Settings"
        PageContent={BusinessInformationPage}
      />
      <PrivateRoutes
        path="/settings/change-password"
        template={DashboardTemplate}
        SubTemplate={SubDashboardTemplate}
        title="Settings"
        PageContent={ChangePassword}
      />
      <PrivateRoutes
        path="/settings/profile"
        template={DashboardTemplate}
        SubTemplate={SubDashboardTemplate}
        title="Settings"
        PageContent={Profile}
      />
      <PrivateRoutes
        path="/settings/subscriptions"
        template={DashboardTemplate}
        SubTemplate={SubDashboardTemplate}
        title="Settings"
        PageContent={Subscriptions}
      />
      <PrivateRoutes
        exact
        path="/announcements"
        template={DashboardTemplate}
        title="Announcements"
        PageContent={AnnouncementsListPage}
      />
     <Route
        exact
        path="/reports"
        render={() => <Redirect to="/reports/location-performance" />}
      />
      <PrivateRoutes
        path="/reports/location-performance"
        template={DashboardTemplate}
        SubTemplate={SubDashboardTemplate}
        title="Reports"
        PageContent={LocationPerformanceReportPage}
      />
      <PrivateRoutes
        path="/reports/employee-performance"
        template={DashboardTemplate}
        SubTemplate={SubDashboardTemplate}
        title="Reports"
        PageContent={EmployeePerformanceReportPage}
      />
      <Route
        path="/verify-email/:token"
        render={(props) => {
          return (
            <OnboardingTemplate>
              <VerifyEmailPage lastScreen={data} />
            </OnboardingTemplate>
          );
        }}
      />
      <PrivateRoutes
        exact
        path="/videos"
        template={DashboardTemplate}
        title="Videos"
        PageContent={VideosPage}
      />
    </Switch>
  );
};
